export enum AppTypes {
    // BAE with Model Designer
    STANDARD = 'standard',

    // AI-first front: a conversation with the BAE agent (npm run start:new-front)
    NEW_FRONT = 'new-front',

    // Digital-Twin Specialized Apps
    GLOBAL_FABRIC = 'global-fabric',
    MIST = 'juniper-mist',
}
